import * as React from "react";
import { Label, Modal } from "reactstrap";
import InputField from "@_common/InputRuleFeild";
import { getValue } from "@utils/lodash";
import { toast } from "react-toastify";
import {
  createChildEntityGroupIC,
  updateChildEntityGroupIC,
} from "@services/internal-compliance.service";
import { sanitizeInput } from "@_common/dompurify";
interface IChoicePopupProps {
  isOpen: boolean;
  handleModal: () => void;
  handleModalCancel: () => void;
  parent_info: any;
  parent_index: number | unknown;
  getEntityList: (id: string, entity_parent: any) => void;
  editEntity: boolean;
  paramsValue: string;
  childEntityList: any;
  setEditEntity: any;
}

const AddChildGroupEntity: React.FunctionComponent<IChoicePopupProps> = (
  props
) => {
  const [entity_name, setEntity_name] = React.useState("");
  React.useEffect(() => {
    // if (getValue(props, `parent_info.id`, "")) {
    setEntity_name(getValue(props, `parent_info.ic_entity_name`, ""));
    // }
  }, [
    // getValue(props, `editEntity`, false),
    getValue(props, `parent_info`, ""),
  ]);


  const [submitLoading, setSubmitLoading] = React.useState(false);
  const handleSubmit = async () => {
    if (entity_name) {
      let payload: any = {
        ic_entity_name: entity_name.trim(),
        ic_entity_group: getValue(props, `parent_info.id`, ""),
        ic_entity_parent: getValue(props, `paramsValue`, "")
          ? parseInt(getValue(props, `paramsValue`, "").split("_")[0])
          : "",
      };
      Object.keys(payload).forEach((key) => {
        if (!payload[key] || payload[key] === undefined) {
          delete payload[key];
        }
      });
      if (getValue(props, `editEntity`, false)) {
        try {
          setSubmitLoading(true);
          let resp = await updateChildEntityGroupIC(
            getValue(props, `parent_info.entity_id`, ""),
            payload
          );
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            props.getEntityList(
              getValue(props, `parent_info.id`, ""),
              parseInt(getValue(props, `paramsValue`, "").split("_")[0])
            );
            props.handleModalCancel();
            setEntity_name("");
            setSubmitLoading(false);
            props.setEditEntity(false);
          } else {
            setSubmitLoading(false);
            props.setEditEntity(false);
          }
        } catch (error) {
          setSubmitLoading(false);
          props.setEditEntity(false);
        }
      } else {
        try {
          setSubmitLoading(true);
          let resp = await createChildEntityGroupIC(payload);
          if (resp) {
            toast.success(getValue(resp, `message`, ""));
            props.handleModalCancel();
            props.getEntityList(
              getValue(props, `parent_info.id`, ""),
              parseInt(getValue(props, `paramsValue`, "").split("_")[0])
            );
            setEntity_name("");
            setSubmitLoading(false);
            props.setEditEntity(false);
          } else {
            setSubmitLoading(false);
            props.setEditEntity(false);
          }
        } catch (error) {
          setSubmitLoading(false);
          props.setEditEntity(false);
        }
      }
    } else {
      toast.error("All fields are mandatory");
    }
  };

  let parentEntity =
    getValue(
      props,
      `childEntityList[${
        getValue(props, `paramsValue`, "").split("_")[1]
      }].length`,
      0
    ) > 0
      ? getValue(
          props,
          `childEntityList[${
            getValue(props, `paramsValue`, "").split("_")[1]
          }]`,
          []
        ).filter(
          (item: any) =>
            item.id == getValue(props, `paramsValue`, "").split("_")[0]
        )
      : [];
  return (
    <Modal
      isOpen={getValue(props, `isOpen`, "")}
      toggle={() => {
        props.handleModalCancel();
        props.setEditEntity(false);
      }}
      centered
      className="common-popup-spacing"
      autoFocus={false}
    >
      <section className="add-popup-wrapper">
        <h3 style={{ textAlign: "center", marginTop: "20px" }}>Group Entity</h3>
        <div className="common-popup-spacing__popup">
          {getValue(parentEntity, `length`, 0) > 0 ? (
            <p className="mb-2 ">
              Parent Entity :{" "}
              <span style={{ color: "#266ef1" }}>
                {getValue(parentEntity, `[${0}].entity_name`, 0)}
              </span>
            </p>
          ) : (
            ""
          )}

          <p className="mb-2 mt-2">
            Group Level :{" "}
            <span style={{ color: "#266ef1" }}>
              {getValue(props, `parent_info.group_level`, "")}
            </span>
          </p>
          <p className="mb-2 ">
            Group Name :{" "}
            <span style={{ color: "#266ef1" }}>
              {getValue(props, `parent_info.group_name`, "")}
            </span>
          </p>

          <br />
          <div className="add-popup-wrapper__form-group form-group">
            <Label>Group Entity Name * </Label>
            <InputField
              inputType="TEXT"
              placeholder="Enter Group Entity Name"
              name={"text"}
              value={entity_name}
              id={"text"}
              onChange={(e: any) => setEntity_name(sanitizeInput(e.target.value))}
              autoFocus={true}
            />
          </div>
          <div className="add-popup-wrapper__cta-wrapper">
            <button
              onClick={() => {
                props.handleModalCancel();
                props.setEditEntity(false);
              }}
              className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--secondary"
            >
              Cancel
            </button>
            <button
              className="add-popup-wrapper__cta-btn add-popup-wrapper__cta-btn--primary"
              onClick={handleSubmit}
              disabled={submitLoading}
            >
              {submitLoading
                ? "Please wait..."
                : props.editEntity
                ? "Update"
                : "Submit"}
            </button>
          </div>
        </div>
        <div className="footer-wrapper d-flex justify-content-between">
          <img src="/images/building-illustration.svg" className="img-fluid" />
        </div>
      </section>
    </Modal>
  );
};

export default AddChildGroupEntity;
